"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPAddress = void 0;
/* eslint-disable */
const minimal_1 = __importDefault(require("protobufjs/minimal"));
function createBaseIPAddress() {
    return { ipAddr: undefined };
}
exports.IPAddress = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.ipAddr?.$case === "v4") {
            writer.uint32(13).fixed32(message.ipAddr.v4);
        }
        if (message.ipAddr?.$case === "v6") {
            writer.uint32(18).bytes(message.ipAddr.v6);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseIPAddress();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.ipAddr = { $case: "v4", v4: reader.fixed32() };
                    break;
                case 2:
                    message.ipAddr = { $case: "v6", v6: reader.bytes() };
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseIPAddress();
        if (object.ipAddr?.$case === "v4" &&
            object.ipAddr?.v4 !== undefined &&
            object.ipAddr?.v4 !== null) {
            message.ipAddr = { $case: "v4", v4: object.ipAddr.v4 };
        }
        if (object.ipAddr?.$case === "v6" &&
            object.ipAddr?.v6 !== undefined &&
            object.ipAddr?.v6 !== null) {
            message.ipAddr = { $case: "v6", v6: object.ipAddr.v6 };
        }
        return message;
    },
};
//# sourceMappingURL=ipaddress.js.map